import React from 'react'

const PageError = (props) => (
    <div className="form-level-error usa-alert usa-alert--error" role="alert">
        <div className="usa-alert__body">
            <p className="usa-alert__text">
                {props.children}
            </p>
        </div>
    </div>
)

export default PageError